import { THREDDS_MSP } from "@/config/data-providers.js";

export default {
  _getWMSRequestUrl(layerScale, layerSector, layerGroup) {
    return `${
      THREDDS_MSP.wmsUrl
    }/${layerScale}/${layerSector}/${layerGroup}/${layerGroup}.nc`;
  },
  _getFutureLayerUrl(url) {
    const ini = url.lastIndexOf("/");
    const end = url.lastIndexOf(".");
    var actualLayerName = url.substring(ini);
    var futureLayerName = `/ClimateChange${url.substring(ini, end)}_CC.nc`;
    return url.replace(actualLayerName, futureLayerName);
  },
  getWMSRequestObj(layerScale, layerSector, layerConfig, options) {
    const wmsUrl = this._getWMSRequestUrl(
      layerScale,
      layerSector,
      layerConfig.metadata.groupName
    );
    return {
      activeLayer: layerConfig.layer.name,
      name: layerConfig.layer.alias,
      url: wmsUrl,
      urlFuture: layerConfig.layer.hasFuture
        ? this._getFutureLayerUrl(wmsUrl)
        : "",
      options: options,
      hasFuture: layerConfig.layer.hasFuture,
      visible: true
    };
  }
};
